module.exports = __webpack_public_path__ + "static/smallbrownbearsuitcase-5cd9b33a4840b829c34de193801938d3.jpeg";